import { TWebsiteBuilderHideableNodeVisibility, websiteBuilderGenerateDefaultHideableNodeVisibility } from "../websiteBuilderHideableNode";
import { TWebsiteBuilderNode } from "../websiteBuilderNode";
import {
  IWebsiteBuilderSectionBase,
  IWebsiteBuilderSectionDataBase,
  websiteBuilderGenerateDefaultSectionBackground,
} from "./websiteBuilderSection";

export interface IWebsiteBuilderContentData extends IWebsiteBuilderSectionDataBase {
  type: "content";
  visibility: TWebsiteBuilderHideableNodeVisibility;
}

export interface IWebsiteBuilderContent extends IWebsiteBuilderSectionBase {
  schemaVersion?: never;
  section: IWebsiteBuilderContentData;
}

export function isWebsiteBuilderContent(node: TWebsiteBuilderNode): node is IWebsiteBuilderContent {
  return node?.type === "section" && node.section?.type === "content";
}

export function websiteBuilderGenerateDefaultContent(): IWebsiteBuilderContent {
  return {
    id: crypto.randomUUID(),
    type: "section",
    section: {
      type: "content",
      layout: {
        desktop: {
          height: 500,
        },
        tablet: {
          height: 400,
        },
        mobile: {
          height: 400,
        },
      },
      background: websiteBuilderGenerateDefaultSectionBackground(),
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
    },
    children: [],
  };
}
